import React, { Component } from 'react';
import BasePage from './BasePage';
import Session from '../services/session'
import Banner from '../partials/Banner';
import i from '../imports';
import c from '../components';
import d from '../dialogs';

import BreadCrumbs from '../partials/BreadCrumbs';

const EMPTY_FILTER_VALUE = "empty_filter_value";

const floatingLabelStyle = {
    color: "#FF5563"
}

const underlineStyle = {
    borderColor: "#FF5563"
}

const titleStyle = {
    fontSize: 28,
    fontWeight: "bold",
    paddingTop: "20px",
    paddingBottom: "10px"
}

const TextStyle = {
    align: "left",
    fontSize: 18,
    paddingTop: "10px"
}

const filterByTourName = (arr, currentTourName) => {
    return arr.filter((obj) => {
        for (let i = 0, length = obj.relation_tours.length; i < length; i++) {
            if (obj.relation_tours[i].tourpages === currentTourName) {
                return true;
            }
        }
        return false;
    });
}


class TourPage extends Component {
    constructor() {
        super();
        this.state = {
            dateValue: new Date(),
            languageValue: EMPTY_FILTER_VALUE,
            toursNumberValue: 1,
            openDialog: false,
            excursionsToDisplay: 6,
            toursToDisplay: 6,
            destinationToDispaly: 6
        }
    }

    showMoreExcursions = () => {
        this.setState({ excursionsToDisplay: this.state.excursionsToDisplay + 6 })
    }

    showMoreTours = () => {
        this.setState({ toursToDisplay: this.state.toursToDisplay + 6 })
    }

    showMoreDestinations = () => {
        this.setState({ destinationToDispaly: this.state.destinationToDispaly + 6 })
    }


    handleDateChange = (event, date) => this.setState({
        dateValue: date
    });

    handleLanguageChange = (event, index, value) => this.setState({
        languageValue: value
    });

    handleToursNumberChange = (event, index, value) => this.setState({
        toursNumberValue: value
    });

    handleOpenDialog = () => {
        this.setState({
            openDialog: true
        })
    }

    handleCloseDialog = () => {
        this.setState({
            openDialog: false
        })
    }

    updateCalcValues = (calcValues) => {
        this.setState({
            toursNumberValue: calcValues.toursNumberValue,
            languageValue: calcValues.languageValue,
            dateValue: calcValues.dateValue
        });
    }

    fillShortExcursionInfo(tour) {
        let tourShortInfo = []

        const getDestinationTranslatedName =  (destination) =>
        {
            return Session.model.destinationPages.filter(f => f.name == destination)[0].translations[0].title;
        }

        tourShortInfo.push({
            icon: i.faIcons.mapMarker,
            text: tour.relation_destinations.map(m => getDestinationTranslatedName(m.destinationpages)).join(', ')
        });

        tourShortInfo.push({
            icon: i.faIcons.clockO,
            text: tour.translations[0].duration
        });

        tourShortInfo.push({
            icon: i.faIcons.hotel,
            text: tour.translations[0].accomodation_info
        });

        tourShortInfo.push({
            icon: i.faIcons.calendar,
            text: tour.translations[0].season_info
        });

        return tourShortInfo;
    }

    calculatePrice(tour){
        let numberOfTourists = this.state.toursNumberValue
        let priceByRange = tour.price_ranges ? tour.price_ranges.filter(f => f.number_from <= numberOfTourists && numberOfTourists <= f.number_to )[0] : undefined;
        let totalPrice = 'N/A';

        if(priceByRange && priceByRange.price)
            totalPrice =  Number(priceByRange.price);
        return totalPrice;
    }



    render() {
        let currentTour = this.props.data;
        let tourDest = currentTour.relation_destinations.map(m => m.destinationpages);

        let otherTours = Session.model.tourPages.filter(tour =>
            tour.type == currentTour.type
            && tour.destination == currentTour.destination
            && tour.name != currentTour.name
        );
        otherTours = i.Utils.sortByIndex(otherTours).slice(0, 3);

        let destinations = Session.model.destinationPages.filter(dest => tourDest.includes(dest.name));
        destinations = i.Utils.sortByIndex(destinations).slice(0, 3);

        let excursions = filterByTourName(Session.model.excursionPages.filter(f => f.relation_tours != undefined), currentTour.name);
        excursions = i.Utils.sortByIndex(excursions);

        let galleryPictures = currentTour.tourImages.map(i => `${i.pic}`);
        let tourShortInfo = this.fillShortExcursionInfo(currentTour);

        let programOutline = currentTour.translations[0] ? currentTour.translations[0].descriptionByDays : undefined;
        if (programOutline != undefined) {
            programOutline = programOutline.map((m) => {
                return {
                    day: m.day_number,
                    dayLocation: m.location,
                    dayDescription: i.markdown(m.plan),
                    pic: m.pic
                }
            })
        }

        let menuItemsForSelection = i.Utils.createArrayOfNumbers(i.Utils.getMaxTouristsNumber(currentTour));
        //let menuItemsForSelection = i.Utils.createArrayOfNumbers(35);

        return (
            <BasePage data={this.props.data}>
                <BreadCrumbs fullpath={window.location.pathname} name={currentTour.translations[0].title} />

                <i.PureGridProvider>
                    <i.Container >
                        <i.Row>
                            <i.Col md={12} align='left' style={titleStyle}>
                                {currentTour.translations[0].title}
                            </i.Col>
                        </i.Row>
                        <i.Row >
                            <i.Col md={8} >
                                <div><c.Gallery images={galleryPictures} /></div>
                                <div style={{ ...TextStyle, textAlign: "justify" }}> {i.markdown(currentTour.translations[0].text)} </div>
                            </i.Col>
                            <i.Col md={4} >
                                <c.IconsWithText data={tourShortInfo} />
                            </i.Col>
                        </i.Row>
                        <i.Row style={{ paddingBottom: 10 }}>
                            <i.Col md={12} >
                                <c.ProgramOutline data={programOutline} title={Session.model.tours.program_ouline} />
                            </i.Col>
                        </i.Row>
                        <i.Row style={{ paddingBottom: 20 }}>
                            <i.Col md={8} align="left" style={{ backgroundColor: "#F5F5F5", padding: "20px" }} >
                                <div style={{
                                    color: "#FF5563",
                                    fontSize: 18,
                                    fontWeight: "bold"
                                }}> {Session.model.tours.services_included}</div>
                                <div class="services-included" style={{ ...TextStyle, align: "left", padding: "20px" }}>
                                    {i.markdown(currentTour.translations[0].tour_services)}
                                </div>
                            </i.Col>
                            {/*<i.Col md={4} >
                                <i.Row>
                                    <i.Col align="left">
                                        <div style={{
                                            color: "#FF5563",
                                            fontSize: 18,
                                            paddingTop: 20,
                                            fontWeight: "bold"
                                        }}>{Session.model.tours.price_calc}</div>
                                    </i.Col>
                                </i.Row>
                                    <i.Row align="end">
                                    <i.Col xs={12} align='left'>
                                        <i.SelectField
                                            floatingLabelText={Session.model.common.words.language}
                                            floatingLabelStyle={floatingLabelStyle}
                                            fullWidth
                                            value={this.state.languageValue}
                                            onChange={this.handleLanguageChange}
                                            underlineFocusStyle={underlineStyle} underlineStyle={underlineStyle}
                                        >
                                            <i.MenuItem value={EMPTY_FILTER_VALUE} primaryText={Session.model.tours.languages.choose_language} />
                                            <i.MenuItem value="Eng" primaryText={Session.model.tours.languages.en} />
                                            <i.MenuItem value="Ru" primaryText={Session.model.tours.languages.ru} />
                                            <i.MenuItem value="Es" primaryText={Session.model.tours.languages.es} />
                                        </i.SelectField>
                                    </i.Col>
                                </i.Row>
                                <i.Row>
                                    <i.Col xs={12} align='left'>
                                        <i.SelectField
                                            floatingLabelText={Session.model.tours.number_of_travellers}
                                            floatingLabelStyle={floatingLabelStyle}
                                            fullWidth
                                            underlineFocusStyle={underlineStyle}
                                            underlineStyle={underlineStyle}
                                            value={this.state.toursNumberValue}
                                            onChange={this.handleToursNumberChange}
                                        >
                                          {menuItemsForSelection.map(m => 
                                            <i.MenuItem value={m} primaryText={`${m}`} /> 
                                            )}
                                        </i.SelectField>
                                    </i.Col>
                                </i.Row>
                                 <i.Row>
                                    <i.Col align="center">
                                        <div style={{
                                            color: "#FF5563",
                                            paddingTop: 40,
                                            fontSize: 18,
                                            fontWeight: "normal"
                                        }}>
                                        {Session.model.common.words.price_for_group || 'Стоимость в составе группы'}<br />
                                         {i.Utils.getGroupPriceTranslatedText(this.state.toursNumberValue)}:&nbsp;
                                            {(this.calculatePrice(currentTour)).toLocaleString("ru-RU")}
                                            <span style={{ textTransform: "uppercase" }}> {Session.model.common.words.rub}* </span>
                                        </div>
                                        <div style={{
                                            color: "#FF5563",
                                            fontSize: 12,
                                            paddingTop: 10,
                                            paddingBottom: 40,
                                            fontWeight: "normal"
                                        }}>*{Session.model.common.words.price_comment}</div>
                                    </i.Col>
                                </i.Row>
                                <i.Row style={{ paddingBottom: 30 }}>
                                    <i.Col xs={12} align="center">
                                        <button className='button' onClick={this.handleOpenDialog}>{Session.model.tours.button}</button>
                                         <d.TourDialog
                                            updateCalcValues={this.updateCalcValues}
                                            form_title={Session.model.tours.form_title}
                                            form_description={Session.model.tours.form_description}
                                            onClose={this.handleCloseDialog}
                                            openDialog={this.state.openDialog}
                                            currentTour={currentTour}
                                            calcValues={this.state}
                                            isSpecificTour={true}
                                        />
                                    </i.Col>
                                </i.Row> 
                            </i.Col>*/}
                        </i.Row>
                        {/* {excursions.length > 0 ?
                            <i.Row style={{ paddingBottom: 20 }}>
                                <i.Col>
                                    <div>
                                        <h2>{`${Session.model.common.words.tour_excursions}`}</h2>
                                        <c.CardsList items={excursions} urlBuilder={i.Utils.createExcursionUrl} />
                                        <h2>
                                            {<i.NavLink style={{ color: "#FF5563", textDecoration: "none" }}
                                                to={i.Utils.locUrl(`excursions`)}>
                                                {Session.model.common.words.find_more}
                                            </i.NavLink>}
                                        </h2>
                                    </div>
                                </i.Col>
                            </i.Row>
                            : null
                        }
                        {otherTours.length > 0 ?
                            <i.Row style={{ paddingBottom: 20 }}>
                                <i.Col>
                                    <div>
                                        <h2>{Session.model.tours.other_tours}</h2>
                                        <c.CardsList items={otherTours} urlBuilder={i.Utils.createTourUrl} />
                                        <h2>
                                            <i.NavLink style={{ color: "#FF5563", textDecoration: "none" }}
                                                to={i.Utils.locUrl(`tours`)}>
                                                {Session.model.common.words.find_more}
                                            </i.NavLink>
                                        </h2>
                                    </div>
                                </i.Col>
                            </i.Row>
                            : null
                        }
                        <i.Row style={{ paddingBottom: 20 }}>
                            <i.Col>
                                {destinations.length > 0 ?
                                    <div>
                                        <h2>{Session.model.common.words.tour_destinations}</h2>
                                        <c.CardsList items={destinations} urlBuilder={i.Utils.createDestinationUrl} />
                                        <h2><i.NavLink style={{ color: "#FF5563", textDecoration: "none" }} to={i.Utils.locUrl("destinations")}>{Session.model.common.words.find_more}</i.NavLink></h2>
                                    </div>
                                    : null
                                }
                            </i.Col>
                        </i.Row> */}
                        {excursions.length > 0 ?
                            <i.Row style={{ paddingBottom: 20 }}>
                                <i.Col>
                                    <div>
                                        <h2>{`${Session.model.tours.tour_excursions}`}</h2>
                                        <c.CardsList items={excursions.slice(0, this.state.excursionsToDisplay)} urlBuilder={i.Utils.createExcursionUrl} />
                                    </div>
                                </i.Col>
                            </i.Row>
                            : null
                        }
                        <i.Row style={{ paddingBottom: 20 }}>
                            <i.Col>
                                {excursions.length > this.state.excursionsToDisplay
                                    ?
                                    <h2 style={{ color: "#FF5563", cursor: "pointer" }} onClick={this.showMoreExcursions}>{Session.model.common.more}</h2>
                                    :
                                    <h2>
                                        {<i.NavLink style={{ color: "#FF5563", textDecoration: "none" }}
                                            to={i.Utils.locUrl(`excursions/`)}>
                                            {Session.model.common.words.find_more}
                                        </i.NavLink>}
                                    </h2>
                                }
                            </i.Col>
                        </i.Row>
                        {otherTours.length > 0 ?
                            <i.Row style={{ paddingBottom: 20 }}>
                                <i.Col>
                                    <div>
                                        <h2>{`${Session.model.tours.other_tours}`}</h2>
                                        <c.CardsList items={otherTours} urlBuilder={i.Utils.createTourUrl} />
                                    </div>
                                </i.Col>
                            </i.Row>
                            : null
                        }
                        <i.Row style={{ paddingBottom: 20 }}>
                            <i.Col>
                                {otherTours.length > this.state.toursToDisplay
                                    ?
                                    <h2 style={{ color: "#FF5563", cursor: "pointer" }} onClick={this.showMoreTours}>{Session.model.common.more}</h2>
                                    :
                                    <h2>
                                        {<i.NavLink style={{ color: "#FF5563", textDecoration: "none" }}
                                            to={i.Utils.locUrl(`tours/}`)}>
                                            {Session.model.common.words.find_more}
                                        </i.NavLink>}
                                    </h2>
                                }
                            </i.Col>
                        </i.Row>
                        {destinations.length > 0 ?
                            <i.Row style={{ paddingBottom: 20 }}>
                                <i.Col>
                                    <div>
                                        <h2>{Session.model.tours.tour_destinations}</h2>
                                        <c.CardsList items={destinations} urlBuilder={i.Utils.createDestinationUrl} />
                                    </div>
                                </i.Col>
                            </i.Row>
                            : null
                        }
                        <i.Row style={{ paddingBottom: 20 }}>
                            <i.Col>
                                {destinations.length > this.state.destinationToDispaly
                                    ?
                                    <h2 style={{ color: "#FF5563", cursor: "pointer" }} onClick={this.showMoreDestinations}>{Session.model.common.more}</h2>
                                    :
                                    <h2><i.NavLink style={{ color: "#FF5563", textDecoration: "none" }} to={i.Utils.locUrl("destinations")}>{Session.model.common.words.find_more}</i.NavLink></h2>
                                }
                            </i.Col>
                        </i.Row>
                    </i.Container>
                </i.PureGridProvider>
            </BasePage>
        );
    }
}

export default TourPage;